<template lang="pug">
.d-flex.flex-column.gap-8.align-center(v-if="event.showQR")
  .event-qr(
    v-html="event.qr_link"
  )
  app-button(
    v-if="canEdit"
    :style-type="STYLE_TYPE.text"
    @click="print"
  ) Распечатать
</template>

<script>
import AppButton, { STYLE_TYPE } from '@/components/user-redesign/controls/AppButton.vue';
import { printContent } from '@/modules/UserEventLanding/functions';

export default {
  components: {
    AppButton,
  },
  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      STYLE_TYPE,
    };
  },

  computed: {
    canEdit() {
      const { $conf, event, $user } = this;
      if (!$user.isEventManager) return event.isOwner;
      const { PERMISSIONS } = $conf;
      return this.$user.hasPermissionsWithManyOptions(
        [PERMISSIONS.event_update],
        [{ event_id: event.id }, {}],
        { all: false },
      );
    },
  },

  methods: {
    print() {
      const { qr_link, name } = this.event;
      const content = `
        <h1 style="text-align: center;">${name}</h1>
        ${qr_link}
        <h4 style="text-align: center;">
          Отсканируй QR код с помощью приложения,<br/>
          чтобы пройти упрощённую регистрацию в качестве участника.
        </h4>
      `;
      printContent(content, 'svg { width: 100%; }');
    },
  },
};
</script>

<style lang="scss" scoped>
.event-qr {
  &::v-deep svg {
    width: 150px;
    height: 150px;
  }
}
</style>
